import $ from "jquery";
import 'slick-carousel';
// import gsap from "gsap";

$('#backBtn').click(function(){
	window.history.back();
});

// Select Integration
if ($('.eligibility-check').length) {

	const urlParams = new URLSearchParams(window.location.search);
	const robotSerialNumber = urlParams.get('sn');

	window.onGigyaServiceReady = function () {

		console.log('onGigyaServiceReady');

		// Get gigya session to retrieve robot data
		gigya.accounts.getAccountInfo({
			include: 'userInfo',
			callback: function (res) {

				// Authorize their creds against iRobot
				$.post('/eligibility-check.php',

					{
						firstName: res.userInfo.firstName,
						lastName: res.userInfo.lastName,
						email: res.userInfo.email,
						uid: res.UID,
						uidSignature: res.UIDSignature,
						signatureTimestamp: res.signatureTimestamp,
						robotSerialNumber: robotSerialNumber,
					},

					function(response, status){

						console.log('robot api response: ' + response);

						// Redirect to plan HP
						if (response == 'protect') {

							window.location.href = window.location.origin + '/services-portal/protect';

						} else if (response == 'protectplus') {

							window.location.href = window.location.origin + '/services-portal/protect-plus';

						} else {

							// Error Handling
							console.log('fail');

						}

					}

				)

			},
		});

	};

}
